import React, { Fragment, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux';

function SeleccionarInstalacionesComponent(props) {

    const dispatch = useDispatch();
    console.log(props.instalaciones)

    const [selectedInstalaciones, setSelectedInstalaciones] = useState([]);

    React.useEffect(() => {
        console.log(selectedInstalaciones)
    }, [selectedInstalaciones])

    const handleCheckboxChange = (id) => {
        console.log(id)
        const isSelected = selectedInstalaciones.includes(id);
        if (isSelected) {
            setSelectedInstalaciones((prevSelected) =>
                prevSelected.filter((selectedId) => selectedId !== id)
            );
        } else {
            setSelectedInstalaciones((prevSelected) => [...prevSelected, id]);
        }
    };

    const handleGenerarDictamen = () => {

        if (selectedInstalaciones.length > 0) {
            var fechaActual = new Date();

            // Obtiene los componentes de la fecha (año, mes y día)
            var año = fechaActual.getFullYear();
            var mes = fechaActual.getMonth() + 1; // ¡Ten en cuenta que los meses se indexan desde 0!
            var dia = fechaActual.getDate();

            // Formatea la fecha sin la hora
            var fechaFormateada = (dia < 10 ? '0' : '') + dia + '/' + (mes < 10 ? '0' : '') + mes + '/' + año;

            // Muestra la fecha formateada en la consola
            let data = {
                cliente: props.cliente,
                fechEmision: fechaFormateada,
                ninforme: "2614-FI2830692/23, 2614-FI2901002/23",
                fechainspeccion: fechaFormateada,
                instalaciones: selectedInstalaciones
            }

            console.log(data)
        }
    }

    return (
        <div className="container mt-4">
            <table className="table">
                <thead>
                    <tr>
                        <th>Alias</th>
                        <th>Dirección</th>
                        <th>Responsable</th>
                        <th>Seleccionar</th>
                    </tr>
                </thead>
                <tbody>
                    {props.instalaciones.map((instalacion) => (
                        <tr key={instalacion.informaciongeneralinstalacioncliente.idiformaciongeneralcliente}>
                            <td>{instalacion.informaciongeneralinstalacioncliente.alias}</td>
                            <td>
                                {instalacion.informaciongeneralinstalacioncliente.calle},{' '}
                                {instalacion.informaciongeneralinstalacioncliente.numeroexterior},{' '}
                                {instalacion.informaciongeneralinstalacioncliente.colonia},{' '}
                                {instalacion.informaciongeneralinstalacioncliente.localidad},{' '}
                                {instalacion.informaciongeneralinstalacioncliente.estado}{' '}
                                {instalacion.informaciongeneralinstalacioncliente.codigopostal}
                            </td>
                            <td>
                                {
                                    instalacion.informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[0]
                                        .nombreresponsable
                                }
                            </td>
                            <td>
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    checked={selectedInstalaciones.includes(instalacion)}
                                    onChange={() => handleCheckboxChange(instalacion)}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <hr />
            <div>
                <p>Instalaciones seleccionadas:</p>
                <ul>
                    {selectedInstalaciones.map((id) => (
                        <li key={id.informaciongeneralinstalacioncliente.idiformaciongeneralcliente}>{id.informaciongeneralinstalacioncliente.alias}</li>
                    ))}
                </ul>
            </div>
            <hr />
            <br />
            <br />
            <div style={{ textAlign: 'end' }}>
                <button className='btn btn-success' onClick={handleGenerarDictamen}>GENERAR</button>
            </div>
        </div>
    );
};


export default withRouter(SeleccionarInstalacionesComponent)